import React from 'react'
import PropTypes from 'prop-types'

const debug = false
// const debug = "MonthSelectionItem"

export default class MonthSelectionItem extends React.Component {
    static propTypes = {
        data        : PropTypes.object,

        onClick     : PropTypes.func,
    }

    render() {
        const classes = Classes("year-month", {
            'selected'          : this.props.data.isSelected,
            'current'           : this.props.data.isCurrent,
            'highlighted'       : this.props.data.isHighlighted,
            'highlighted-start' : this.props.data.isHighlightedStart,
            'highlighted-end'   : this.props.data.isHighlightedEnd,
        })
        return (
            <div className  = {classes}
                 onClick    = {()=>this.props.onClick(this.props.data.moment)}>
                {this.props.data.moment.format("MMM")}
            </div>
        )
    }
}